var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrantedLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI Cards/Resources/Sign In Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Cards/Bundles/Item-Granted/Rest",
    transform: "translate(-261, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(261, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9941406,0 C41.2032796,-4.05812251e-16 42.9941406,1.790861 42.9941406,4 L42.9941406,42 C42.9941406,42.291632 42.9629312,42.5759746 42.90367,42.8498702 C31.4797638,31.4415099 22.3384697,22.3113242 15.4778906,15.459082 L14.4632289,14.4456533 C14.1307409,14.1135693 13.8039854,13.7872109 13.4829625,13.4665781 L12.5370914,12.5218564 C11.7631969,11.7489023 11.0251308,11.0117332 10.3228932,10.3103489 L9.49740566,9.4858645 C9.09326074,9.08221069 8.70201406,8.69143945 8.32366563,8.31355078 L7.58416641,7.5749502 C6.74148125,6.73328906 5.96901986,5.96176636 5.26678223,5.26038208 L4.68206191,4.67637231 C4.5874748,4.58190015 4.49432083,4.48885938 4.4026,4.39725 L3.86947266,3.86477051 C3.78348438,3.77888672 3.69892923,3.69443433 3.61580723,3.61141333 L2.68713379,2.68386841 C2.32884928,2.32601929 2.00639323,2.00395508 1.71976563,1.71767578 L1.39301016,1.39131738 C1.34141719,1.33978711 1.29125736,1.28968823 1.24253066,1.24102075 L0.520229102,0.519596924 C0.394112956,0.393634033 0.290927018,0.290573486 0.210671289,0.210415283 L0,0 L38.9941406,0 Z",
    id: "Combined-Shape",
    fill: "#658BD3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "circle-check",
    transform: "translate(23.9941, 5.75)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7 C0,3.13359392 3.13359392,0 7,0 C10.8664061,0 14,3.13359392 14,7 C14,10.8664061 10.8664061,14 7,14 C3.13359392,14 0,10.8664061 0,7 Z M10.1664059,5.79140633 C10.4644535,5.49335921 10.4644535,5.00664079 10.1664059,4.70859408 C9.86835921,4.41054654 9.38164079,4.41054654 9.08359408,4.70859408 L6.125,7.66718733 L4.91640633,6.45859367 C4.61835921,6.16054696 4.13164079,6.16054696 3.83359367,6.45859367 C3.53554696,6.75664079 3.53554696,7.24335921 3.83359367,7.54140592 L5.58359367,9.29140592 C5.88164079,9.58945346 6.36835921,9.58945346 6.66640633,9.29140592 L10.1664059,5.79140633 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantedLabel);
export default __webpack_public_path__ + "static/media/granted-label.9e7e17d93143abc6dc0242bb4f6b1125.svg";
export { ForwardRef as ReactComponent };